<template>
  <div class="popup-type-item">
    <el-dialog append-to-body :visible.sync="visible" title="Thêm nhanh theo loại sản phẩm" :close-on-click-modal="false" width="500px">
      <div>
        <el-input v-model="txtSearch" placeholder="Tìm kiếm loại sản phẩm" clearable />
        <ol class="change-quantity-list-serie" style="height: 40vh;">
          <li v-for="category in categorysDisplay" :key="category.id" class="line-expand">
            <div @click="handleExpand(category)">
              <i class="fa-solid fa-chevron-up" v-if="category.expand" style="padding-left: 2px;"></i>
              <i class="fa-solid fa-chevron-down" v-else style="padding-left: 2px;"></i>
              <span style="padding-left: 15px; font-weight: bold;">
                {{ category.name }}
              </span>
            </div>
            <div v-if="category.expand" style="padding-top: 10px;">
              <b-form-group style="margin-bottom: 5px;">
                <template #label>
                  <b-form-checkbox
                    v-model="category.allSelected"
                    aria-describedby="flavours"
                    aria-controls="flavours"
                    @change="toggleAll(category)"
                  >
                    {{ category.allSelected ? 'Bỏ chọn tất cả' : 'Tất cả' }}
                  </b-form-checkbox>
                </template>
                <template v-slot="{ ariaDescribedby }">
                  <b-form-checkbox
                    v-for="children in category.childrens"
                    v-model="selected"
                    :key="children.id"
                    :value="children.id"
                    style="padding: 10px 24px;"
                  >
                    <span style="padding-left: 8px;">
                      {{ children.name }}
                    </span>
                  </b-form-checkbox>
                </template>
              </b-form-group>
            </div>
          </li>
        </ol>
      </div>
      <template slot="footer">
        <el-button @click="visible = false">Thoát</el-button>
        <el-button type="primary" :loading="btnLoading" @click="btnConfirm">Hoàn tất</el-button>
      </template>
    </el-dialog>
    <div @click="visible = true">
      Chọn nhanh theo loại sản phẩm
    </div>
  </div>
</template>

<script>
import { categoryGetList } from '@/api/category.js'
import { getItemByCategory } from '../../api/inventory'
export default {
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      categorys: [],
      categorysDisplay: [],
      txtSearch: '',
      visible: false,
      btnLoading: false,
      selected: []
    }
  },
  watch: {
    txtSearch() {
      this.categorysDisplay = this.categorys.filter(cate => {
        return cate.name.toLowerCase().indexOf(this.txtSearch) !== -1
      })
    },
    categorys() {
      this.categorysDisplay = [...this.categorys]
    },
    selected() {
      console.log(this.selected);
    }
  },
  created() {
    this.getCategoryList()
  },
  methods: {
    toggleAll(arrs) {
      if (arrs.allSelected) {
        arrs.childrens.forEach((chil) => {
          const checkExist = this.selected.includes(chil.id)
          if (!checkExist) {
            this.selected.push(chil.id)
          }
        })
      } else {
        arrs.childrens.forEach((chil) => {
          const checkExist = this.selected.findIndex(select => select === chil.id)
          if (checkExist !== -1) {
            this.selected.splice(checkExist, 1)
          }
        })
      }
    },
    btnConfirm() {
      const search = this.selected.map(select => `'''${select}'''`).join(", ")
      const req = {
        queryString: `{category.categoryId} in [${search}]`,
        pagingAndSorting: {
          sortOrder: 'DESC',
          lastIndex: '',
          limit: 100
        }
      }
      this.btnLoading = true
      getItemByCategory(req).then(res => {
        this.btnLoading = false
        if (res.success) {
          this.visible = false
          this.$emit('response', res.data)
        }
      })
    },
    handleExpand(obj) {
      obj.expand = !obj.expand
      if (obj.expand) {
        this.getCategoryList(obj.id)
      }
    },
    getCategoryList(categoryId) {
      const params = {
        queryString: { parentId: { eq: categoryId ? categoryId : '' } },
        sort: "-id",
        lastItem: "",
        limit: 100,
      }
      categoryGetList(params).then(res => {
        if (res.success) {
          if (categoryId) {
            if (res.data.length === 0) {
              return
            }
            const parentId = res.data[0].parentId
            let category = this.categorysDisplay.find(cate => cate.id === parentId)
            let childrens = res.data.map((child) => {
              return {
                ...child,
                choose: false
              }
            })
            if (category) {
              category.childrens = childrens
            }
          } else {
            const response = res.data.map(cate => {
              return {
                ...cate,
                expand: false,
                allSelected: false,
                childrens: []
              }
            })
            this.categorys = response
            this.categorysDisplay = response
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>